import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import VideoCover from 'react-video-cover'
import theme from 'ui/styles/theme'

export default class ProductLandingHero extends Component {
  state = {
    isMobile: false
  }

  componentDidMount() {
    this.detectMobile()

    window.addEventListener('resize', this.detectMobile)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.detectMobile)
  }

  detectMobile = () => {
    const width = window.innerWidth
    const isMobile = width <= theme.grid.breakpoints.md

    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })
    }
  }
  
  render() {
    const {
      title,
      buttonText,
      buttonLink,
      backgroundImage,
      backgroundVideo,
      backgroundVideoMobile
    } = this.props

    const { isMobile } = this.state

    const videoOptions = {
      src: isMobile ? (backgroundVideoMobile && backgroundVideoMobile.sourceUrl) : (backgroundVideo && backgroundVideo.sourceUrl),
      autoplay: 'autoplay',
      playsInline: 'playsInline',
      muted: 'muted',
      loop: 'loop'
    }
    
    return (
      <Wrapper image={backgroundImage && backgroundImage.sourceUrl}>
        <Content>
          <Container fluid>
            <Row alignItems="end">
              <Col sm={10}>
                <Title>{title}</Title>
              </Col>
              {buttonLink && buttonText && (
                <Col sm={2}>
                  <ButtonContainer>
                    <Button to={getRelativeUrl(buttonLink)}>{buttonText}</Button>
                  </ButtonContainer>
                </Col>
              )}
            </Row>
          </Container>
        </Content>

        {backgroundVideo && (
          <Video videoOptions={videoOptions} />
        )}
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
  height: 80vh;
  background: url(${props => props.image}) center / cover;
  display: flex;
  align-items: flex-end;
  padding-bottom: 50px;
  position: relative;
  margin-bottom: 0px;
`

const Content = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
`

const Title = styled.h1`
  font-size: 80px;
  color: white;
  line-height: 100px;
  margin: 0;

  ${media.xs`
    font-size: 40px;
    line-height: normal;
    margin-bottom: 25px;
  `}
`

const ButtonContainer = styled.div`
  text-align: right;

  ${media.xs`
    text-align: left;
  `}
`

const Button = styled(Link)`
  text-transform: uppercase;
  padding: 0.5em 1.5em;
  color: white;
  border: 1px solid white;
  border-radius: 2em;
  font-size: 12px;
  font-weight: 500;
`

const Video = styled(VideoCover)`
  display: block;
  position: absolute !important;
  top: 0;
  left: 0;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductLandingHero/index.js